/// <amd-module name="ExtensionManagement/ManagementHub/SecurityDialog" />
import * as React from "react";

import { IRoleAssignmentProps } from "VSS/Features/SecurityUI/Roles/Components/RoleAssignment.Props";
import { WrappedComponent } from "VSS/Platform/Layout";

import { ContentSize } from "VSSUI/Callout";
import { CustomDialog } from "VSSUI/Dialog";
import { PanelHeader, PanelFooter, PanelContent } from "VSSUI/Panel";
import { Spinner, SpinnerSize } from "VSSUI/Spinner";

import * as Resources from "ExtensionManagement/ManagementHub/Resources.ExtManagmentHub";

const extensionManagmentServiceInstanceId = "00000028-0000-8888-8000-000000000000";
const LargeSpinner = () => <Spinner className="pool-security-spinner scroll-hidden" size={SpinnerSize.large} />;

interface SecurityDialogProps {
    /**
     * Callback function on dismissing the dialog
     */
    onDismiss: () => void;

    /**
     * If current user has permissions to manage security or not
     */
    canUserManageSecurity: boolean;

    /**
     * user ID of current user
     */
    userId: string;

    /**
     * If the security dialog should support adding service principals
     */
    supportServicePrincipals: boolean;
}

/**
 * Security dialog shows list of user groups and permissions
 */
export class SecurityDialog extends React.Component<SecurityDialogProps> {
    public render(): JSX.Element {
        const { canUserManageSecurity, userId } = this.props;

        return (
            <CustomDialog
                calloutContentClassName="ems-security-dialog"
                contentSize={ContentSize.Large}
                onDismiss={this.props.onDismiss}
            >
                <PanelHeader className="bolt-header-condensed" titleProps={{ text: Resources.Security }} onDismiss={this.props.onDismiss}></PanelHeader>
                <PanelContent>
                    <div className="flex-grow flex-column scroll-auto security-dialog-content">
                        <WrappedComponent
                            dependencies={["ms.vss-features.security-ui-roles-management"]}
                            loadingComponent={LargeSpinner}
                            wrappedProps={
                                {
                                    canEdit: canUserManageSecurity,
                                    manageRolesPermission: 2 /*ExtensionManagementPermissions.ManageExtensions*/,
                                    noPermissionMessage: Resources.SecurityRolesNoPermissionToManageMessage,
                                    resourceId: "ems-ui",
                                    resourceName: Resources.SecurityRolesResourceName,
                                    scopeId: "ems.manage.ui",
                                    serviceInstanceId: extensionManagmentServiceInstanceId,
                                    userId,
                                    identityTypes: this.props.supportServicePrincipals ? ["user", "group", "servicePrincipal"] : ["user", "group"]
                                } as IRoleAssignmentProps
                            }
                            wrappedType="vss-security-ui.role-assignment"
                        />
                    </div>
                </PanelContent>
                <PanelFooter
                    buttonProps={[
                    {
                        text: Resources.Close,
                        onClick: this.props.onDismiss
                    }
                ]}></PanelFooter>
            </CustomDialog>
        );
    }
}
